'use strict';
var parent = require('../../actual/object/define-properties');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/object/define-properties.js
// module id = 631
// module chunks = 13